import { createBrowserHistory, createMemoryHistory, type History } from 'history'
import { isServer } from 'common/config/helpers'

const history: History = isServer ? createMemoryHistory() : createBrowserHistory()

export default history
